import { useState, type ReactNode } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useHotkey } from '@/hooks/useHotkey'
import { useNavigationStore } from '@/stores/navigationStore'
import { CommandPalette } from '@/components/overlay/CommandPalette'
import { KeyboardShortcutsHelp } from '@/components/overlay/KeyboardShortcutsHelp'

/**
 * Global keyboard shortcuts handler component.
 * Provides app-wide shortcuts for navigation and UI actions.
 */
export function GlobalShortcuts(): ReactNode {
  const navigate = useNavigate()
  const location = useLocation()
  const { toggleSidebar } = useNavigationStore()

  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false)
  const [shortcutsHelpOpen, setShortcutsHelpOpen] = useState(false)

  // Cmd+K - Open command palette / search
  useHotkey({
    key: 'k',
    modifiers: ['meta'],
    callback: () => setCommandPaletteOpen(true),
  })

  // Cmd+. - Toggle sidebar
  useHotkey({
    key: '.',
    modifiers: ['meta'],
    callback: toggleSidebar,
  })

  // Cmd+, - Open settings
  useHotkey({
    key: ',',
    modifiers: ['meta'],
    callback: () => {
      if (location.pathname !== '/settings') {
        void navigate('/settings')
      }
    },
  })

  // Cmd+/ or ? - Open keyboard shortcuts help
  useHotkey({
    key: '/',
    modifiers: ['meta'],
    callback: () => setShortcutsHelpOpen(true),
  })

  useHotkey({
    key: '?',
    modifiers: ['shift'],
    callback: () => setShortcutsHelpOpen(true),
  })

  return (
    <>
      <CommandPalette isOpen={commandPaletteOpen} onClose={() => setCommandPaletteOpen(false)} />
      <KeyboardShortcutsHelp
        isOpen={shortcutsHelpOpen}
        onClose={() => setShortcutsHelpOpen(false)}
      />
    </>
  )
}
